angular.module('agreements')
    .component('agreementCategoryPicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            modelType: "<?",
            filterField: "<?",
            disableList: "<?",
            disableAdd: "<?",
            onChange: "&"
        },
        templateUrl: "app/agreements/agreement-category/picker.html",
        controller: function(AgreementCategory, AgreementCategoryService) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.filterField = ctrl.filterField || false;
                ctrl.disableList = ctrl.disableList || false;
                ctrl.disableAdd = ctrl.disableAdd || false;

                ctrl.loadItems()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
            ctrl.loadItems = () => AgreementCategory.list().$promise.then(items => ctrl.items = items)
            ctrl.add = () => AgreementCategoryService.add().then(() => ctrl.loadItems())
            ctrl.list = () => AgreementCategoryService.list().then(() => ctrl.loadItems())
        }
    })
